import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {
  const {
    spacing,
  } = theme;

  return {
    default: {
      header: {
        display: 'flex',
        flexDirection: 'column',
      },
      save: {
        flex: '0 1 auto', // IE11 default is 0 0 auto
        marginTop: gu2px(1, spacing),
        opacity: 1,
        maxHeight: 60,
        transition: 'opacity 0.3s ease-in-out, max-height 0.3s ease-in-out',
      },
    },

    tablet: {
      header: {
        flexDirection: 'row',
      },
      save: {
        maxHeight: 'auto',
        marginLeft: gu2px(2, spacing),
        textAlign: 'right',
      },
    },

    pristine: {
      save: {
        opacity: 0,
        maxHeight: 0,
      },
    },
    submitSucceeded: {
      save: {
        opacity: 0,
        maxHeight: 0,
        transition: '1s opacity 0.3s ease-in-out, 1s max-height 0.3s ease-in-out',
      },
    },
  };
};
